import getApiInstance from '@/services/Api.ts'

type AccountStatus = {
  has_account: boolean
  has_verified_mobile: boolean
  is_super_fund_member: boolean
  has_member_id: boolean
  has_super_account: boolean
  has_super_account_number: boolean
  has_fee_consent: boolean
  dtd_member: boolean
}

export default async () => {
  const api = getApiInstance()
  try {
    const res: { data: AccountStatus } = await api.Get('/v3/valid-user')
    return res.data
  } catch (e: any) {
    if (e.response?.status === 404) return
    throw e
  }
}
